const COMPONENT_NAME = "FindAWarehouseLink";
const ICON_SIZE_SM = "22px";
export {
  COMPONENT_NAME,
  ICON_SIZE_SM
};
